import React, { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { DataExtenso, formatarData } from "../../../components/Formatters/DateTime";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import removeHTML from "../ProrrogacaoOS/components/RemoveHTML";

const useTextoPadraoModal = () => {
  const [textoPadraoModalShow, setTextoPadraoModalShow] = useState(false);
  const [conteudo, setConteudo] = useState();
  const [textoPadrao, setTextoPadrao] = useState();
  const [procedimento, setProcedimento] = useState([]);

  const listaExecutor = conteudo !== null ? conteudo?.executores.map((e) => ` ${e.nomeFormal} `) : "";
  const listaProcedimentos = conteudo !== null ? conteudo?.procedimentos.map((e) => e) : "";

  const { request, data, errors } = useApiClient();

  useEffect(() => {
    const parametros = { sqTipoAcaoFiscal: conteudo?.sqTipoAcao };
    if (parametros !== undefined && parametros.sqTipoAcaoFiscal !== undefined) {
      request(apiRoutes.fiscalizacao.parametrizacao.consultaAtividadePadraoAF, parametros);
    }
  }, [conteudo?.sqTipoAcao, request]);

  useEffect(() => {
    if (!data && !errors) return;

    if (data?.result.length > 0) {
      setTextoPadrao(removeHTML(data.result[0].txTextoPadrao));
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors]);

  // Carregando lista de procedimentos por SqTipoAcaoFiscal
  const { request: requestProcedimento, data: dataProcedimento, errors: erroProcedimento } = useApiClient();

  useEffect(() => {
    if (conteudo?.sqTipoAcao) {
      const params = { sqTipoAcaoFiscal: conteudo?.sqTipoAcao };
      if (params !== undefined && params.sqTipoAcaoFiscal !== undefined) {
        requestProcedimento(apiRoutes.fiscalizacao.procedimentoFiscal.consultaProcedimentosPorAcao, params);
      }
    }
  }, [conteudo?.sqTipoAcao, requestProcedimento]);

  useEffect(() => {
    if (dataProcedimento) {
      setProcedimento(dataProcedimento.result);
    }

    if (erroProcedimento) {
      toast.error(erroProcedimento.message);
    }
  }, [dataProcedimento, erroProcedimento]);

  const listaProcedimentosFilter = listaProcedimentos?.map((p) =>
    procedimento.filter((proc) => proc.codigo === parseInt(p, 10)).map((proc) => ` ${proc.codigo} - ${proc.nome} `),
  );

  const dataRodape = (
    <div style={{ marginTop: 70, textAlign: "center" }}>
      <p style={{ marginBottom: 60 }}>
        <DataExtenso value={new Date()} />
      </p>
    </div>
  );

  const textoPadraoModal = (
    <Modal size="lg" show={textoPadraoModalShow} onHide={() => setTextoPadraoModalShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Pré-Visualização da OS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <br />
        <Form.Group className="m-0" style={{ marginTop: 30 }}>
          <h4 style={{ textAlign: "center" }}>INFORMAÇÃO</h4>
          <p style={{ marginTop: 20 }}>
            {conteudo !== null ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: textoPadrao
                    ?.replace("[EXECUTORES]", `<strong> ${listaExecutor} </strong>`)
                    .replace("[TEXTO]", `<br><br><strong>${conteudo?.texto}</strong> `)
                    .replace(
                      "[PERIODO_FISCALIZACAO]",
                      `<strong> ${formatarData(conteudo?.dataIni)} à ${formatarData(conteudo?.dataFim)} </strong>`,
                    )
                    .replace("[PROCEDIMENTOS]", `<br/><br/><strong> ${listaProcedimentosFilter} </strong><br/><br/>`),
                }}
              />
            ) : (
              ""
            )}
            {dataRodape}
          </p>

          <Modal.Footer>
            <Button style={{ marginTop: 15 }} variant="primary" onClick={() => setTextoPadraoModalShow(false)}>
              Fechar
            </Button>
          </Modal.Footer>
        </Form.Group>
      </Modal.Body>
    </Modal>
  );

  return {
    textoPadraoModal,
    setTextoPadraoModalShow,
    setConteudo,
  };
};

export default useTextoPadraoModal;
